<template>
  <b-modal size="lg" :hide-footer="true" :hide-header="true" ref="bulletinViewModal" @show="viewWillShow" @hidden="empty">
    <b-progress v-if="isLoading" :value="100" variant="warning" :animated="true" class="mb-3"></b-progress>
    <template v-else>
      <b-row>
        <b-col cols="9">
          <p class="h2 text-left">{{ bulletin.subject }}</p>
        </b-col>
        <b-col cols="3" v-if="editable" class="text-right">
          <b-button variant="warning" size="md" @click="editBulletin"><i class="fa fa-edit mr-2"></i>{{ $t('home.message.bulletin.edit') }}</b-button>
        </b-col>
      </b-row>
      <p class="text-secondary text-left">
        <span>
    <i class="fa fa-calendar mx-2"></i>{{ bulletin.updateTime | date }}
  </span>
        <span>
    <i class="fa fa-user mx-2"></i>{{ bulletin.englishName }} ({{ bulletin.chineseName }})
  </span>
        <span>
    <i class="fa fa-align-center mx-2"></i>{{ getConvertedCategory(bulletin.category) }}
  </span>
      </p>
      <p class="text-secondary text-left"><i class="fa fa-building mx-2"></i>
        <template v-for="(item,index) in bulletin.providerID">
          <span class="mr-2">{{getTranslatedValue($i18n.locale,'Adm','providerID',item)}} |</span>
        </template>
        <span v-if="bulletin.providerID.length == 0">N/A</span>
      </p>
      <p class="text-secondary text-left"><i class="fa fa-file-alt mx-2"></i>
        <template v-for="item in bulletin.policyType">
          <span class="mr-2">{{getTranslatedValue($i18n.locale,'Adm','policyType',item) }} |</span>
        </template>
        <span v-if="bulletin.policyType.length == 0">N/A</span>
      </p>
      <p><span v-html="bulletin.content"></span></p>
      <hr>
      <template v-if="bulletin.attachments.length > 0">
        <dl class="row">
          <dt class="col-5">{{$t('home.message.bulletin.attachment')}}</dt>
          <dd class="col-7">
            <ol>
              <template v-if="bulletin.attachments.length > 0" v-for="item in bulletin.attachments">
                <li><a :href="fileDownloadPrefix+ item.ID">{{item.documentName}}</a></li>
              </template>
              <li v-if="bulletin.attachments.length == 0">N/A</li>
            </ol>
          </dd>
        </dl>
      </template>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { domain } from '@/api/api.js'
export default {
  name: 'BulletinView',
  props: {
    editable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      fileDownloadPrefix: domain + '/dm/document/download?ID=',
      bulletin: {
        ID: 0,
        subject: '',
        category: '',
        createTime: '',
        content: '',
        englistName: '',
        chineseName: '',
        attachments: [],
        providerID: [],
        policyType: [],
      }
    }
  },

  computed: {
    ...mapGetters('Homepage', [
      'getTranslated'
    ]),
    ...mapGetters(['getTranslatedValue']),
    categories() {
      return this.getTranslated(this.$i18n.locale, 'category');
    }
  },
  components: {},
  methods: {
    getConvertedCategory(key) {
      let result = this.categories.filter((item) => {
        return item.value === key;
      });

      if (result.length > 0) {
        return result[0].text;
      }

      return 'N/A';
    },

    editBulletin() {
      this.$router.push({
        name: 'Create Bulletin',
        params: {
          bulletin: parseInt(this.bulletin.ID)
        }
      })
    },

    show(ID) {
      this.bulletin.ID = ID;
      this.$refs['bulletinViewModal'].show();
    },
    empty() {
      Vue.set(this, 'bulletin', {
        ID: 0,
        subject: '',
        category: '',
        createTime: '',
        content: '',
        englistName: '',
        chineseName: '',
        attachments: []
      });
    },
    viewWillShow() {
      Vue.set(this, 'isLoading', true);
      this.$store.dispatch('Homepage/getBulletinDetail', {
          ID: this.bulletin.ID
        })
        .then((json) => {
          console.debug(json);
          Vue.set(this, 'bulletin', json);
          Vue.set(this, 'isLoading', false);
        })
        .catch((err) => {
          console.debug(err);
        });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Bulletin/BulletinView.vue